import { useState } from "react";
import { toast } from "sonner";
import type { ApiUploadProgress, ConversationMediaAttachmentView } from "@/api/autoparts";

import { validateChatFiles } from "./chat-attachment-validation";
export { validateChatFiles, SHOP_MESSAGE_MAX_ATTACHMENTS, SHOP_MESSAGE_MAX_VIDEO_BYTES, SHOP_MESSAGE_MAX_OTHER_BYTES, SHOP_MESSAGE_ACCEPTED_TYPES } from "./chat-attachment-validation";

export function useChatAttachments() {
  const [files, setFiles] = useState<File[]>([]);
  const [progress, setProgress] = useState<number | null>(null);
  const addFiles = (incoming: File[]) => setFiles((existing) => {
    const { accepted, rejected } = validateChatFiles(incoming, existing);
    rejected.forEach(({ file, reason }) => toast.error(`${file.name}: ${reason}`));
    return [...existing, ...accepted];
  });
  const removeAt = (index: number) => setFiles((existing) => existing.filter((_, i) => i !== index));
  const clear = () => { setFiles([]); setProgress(null); };
  const upload = async (send: (file: File, onProgress: (progress: ApiUploadProgress) => void) => Promise<ConversationMediaAttachmentView>) => {
    const result: ConversationMediaAttachmentView[] = [];
    for (let i = 0; i < files.length; i += 1) {
      result.push(await send(files[i], (value) => {
        const percentage = typeof value.total === "number" && value.total > 0 ? (value.loaded / value.total) * 100 : (value.percent ?? 0);
        setProgress(Math.round(((i + percentage / 100) / files.length) * 100));
      }));
    }
    return result;
  };
  return { files, setFiles, addFiles, removeAt, clear, progress, setProgress, upload };
}
